import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Alert, Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import classNames from 'classnames';

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {confirmAlert} from "react-confirm-alert";
import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";

import Select from "react-select";
import CollectionOverride from "components/CollectionOverride";
import UniversalModalOverride from "../UniversalModalOverride";
import {Objects} from "../index";


export default class OrdersAmmoready extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Ammoready_Orders._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.caliber = '';
		this.state.caliber_error = '';
		this.state.calibers = null;
		this.state.manufacturer = '';
		this.state.manufacturer_error = '';
		this.state.manufacturers = null;
		this.state.type = '';
		this.state.type_error = '';
		this.state.types = null;
		this.state.transferModal = false;
		this.state.products = [];
		this.state.products_error = "";
		this.state.acquisitionModal = false;
		this.state.loading = false;
		this.state.transfer_error = false;
		this.state.not_acquired_error = false;
		this.state.already_acquired_error = false;
		this.state.isModalOpen = false;


	}

	customStyles = {
		menu: (provided) => ({
			...provided, zIndex: 9999
		})
	};


	// componentDidMount() {
	// 	console.log('in component did mount', this);
	//
	// }

	printLabel = (e) => {
		const {data} = this.state;
		let pkey = e.currentTarget.id;
		let binary_id = e.currentTarget.getAttribute('data-binary-id');
		let product;
		let longBarCode, shortBarCode;
		switch (pkey) {
			case 'all':
				longBarCode = data.map((product, key) => <ProductLong key={key} product={product}/>)
				shortBarCode = data.map((product, key) => <ProductShort key={key} product={product}/>)
				break;
			default: {
				pkey = parseInt(pkey);
				product = data.find((item) => item.pkey === pkey && item.binary_id === binary_id);
				longBarCode = <ProductLong product={product}/>
				shortBarCode = <ProductShort product={product}/>
			}
		}

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						onClose={onClose}
						longBarCode={longBarCode}
						shortBarCode={shortBarCode}
						showFullLabel={true}
					/>
				);
			}
		});
	};

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		let updatedState;
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			} else {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			}
		} else {
			updatedState = {
				[property]: value,
			};
		}
		this.setState(updatedState);
		this.doFilter({'value': value}, {'name': property});
	};

	clearFilters = () => {
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			startDate: '',
			endDate: '',
			filterLocation: null,
			filterStatus: null,
			filterUsed: null,

			caliber: '',
			calibers: null,
			manufacturer: '',
			manufacturers: null,
			type: '',
			types: null,
		});
		let path = window.location.pathname.replaceAll('/', ' ').titleCase().replaceAll(' ', '');
		localStorage.removeItem('table-preferences-' + path);
	}


	transferFFL = () => {
		this.setState({myProduct: this.state.products, transferModal: true})
		// this.setState({transferModal: true});
	}

	handleReportClose = (e) => {
		this.setState({[e]: false});
	}

	removeObjectByKeyValue(products, key, valueToRemove) {
		return products.filter(product => product[key] !== valueToRemove);
	}


	getAmmoreadyOrders = async () => {
		this.setState({loading: true})
		let oModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_ORDERS');
		await oModel.submit(null, 'GET_AMMOREADY_ORDERS');
		this.reloadTable();
		this.setState({loading: false});
	}

	addForAcquisition = async (orderId) => {
		// const {data, products} = this.state;

		this.setState({loading: true, transfer_error: false, not_acquired_error: false, already_acquired_error: false})
		let apModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_PRODUCTS');
		apModel.object.ammoready_order_id = orderId;
		let ammoready_products = await apModel.submit(null, 'GET_AMMOREADY_PRODUCTS');

		// let alreadyAcquired = false;
		// for(let i = 0; i < ammoready_products.items.length; i++) {
		// 	if (ammoready_products.items[i].status !== 8) {
		// 		alreadyAcquired = true;
		// 		break;
		// 	}
		//
		// }
		//
		// if(alreadyAcquired) {
		// 	await this.setState({
		// 		already_acquired_error: true,
		// 		loading: false,
		// 	})
		// }
		// else {
			await this.setState({
				ammoready_products: ammoready_products.items,
				loading: false,
				acquisitionModal: true
			})
		// }

	};



	addForTransfer = async (orderId) => {
		// const {data, products} = this.state;

		this.setState({loading: true, transfer_error: false, not_acquired_error: false, already_acquired_error: false})
		let apModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_PRODUCTS');
		apModel.object.ammoready_order_id = orderId;
		let ammoready_products = await apModel.submit(null, 'GET_AMMOREADY_PRODUCTS');


		// Set up already acquired logic to prevent acq modal form popping
		let not_acquired, alreadyTransferred = false;

		for(let i = 0; i < ammoready_products.items.length; i++) {
			if(ammoready_products.items[i].status === 8) {
				not_acquired = true;
				break;
			}
			if(ammoready_products.items[i].status === 3) {
				alreadyTransferred = true;
				break;
			}

		}

		if(not_acquired) {
			await this.setState({
				not_acquired_error: true,
				loading: false,
			})
		}
		else if (alreadyTransferred) {
			await this.setState({
				transfer_error: true,
				loading: false,
			})
		}
		else {
			await this.setState({
				ammoready_products: ammoready_products.items,
				loading: false,
				transferModal: true
			})
		}
	};


	addForDisposition = async (orderId) => {
		// const {data, products} = this.state;
		// const orderId = e.currentTarget.id;

		this.setState({loading: true, transfer_error: false, not_acquired_error: false, already_acquired_error: false})
		let gbModel = new API.BuildClass(Types.Products._name, 'GET_AMMOREADY_PRODUCTS');
		gbModel.object.ammoready_order_id = orderId;
		let ammoready_products = await gbModel.submit(null, 'GET_AMMOREADY_PRODUCTS');

		this.setState({
			ammoready_products: ammoready_products.items,
			loading: false,
			dispositionModal: true
		})

	};


	handleAcquisitionModal = () => {
		this.setState({acquisitionModal: true});
	}

	toggleModalOpen = (e) => {
		let orderID = e.currentTarget.id;

		this.setState(prevState => ({
			isModalOpen: !prevState.isModalOpen,
			orderID: orderID
		}));
	};

	toggleModalClose = async () => {
		this.setState(prevState => ({
			isModalOpen: !prevState.isModalOpen
		}));
	};


	handleTransactionSelect = async (type) => {
		await this.toggleModalClose();

		if(type === 'acquisition') {
			await this.addForAcquisition(this.state.orderID)
		}
		if(type === 'transfer') {
			await this.addForTransfer(this.state.orderID)
		}
		if(type === 'disposition') {
			await this.addForDisposition(this.state.orderID)
		}
		// Add your transaction handling logic here
	};



	render() {
		const {data, pages, limit, loading,columnsAnchor} = this.state;
		const extraColumns = [

		];
		const columns = [
			{
				Header: "Order ID",
				id: "order_id",
				width: 100,
				accessor: obj => "AR-" + obj.order_id
			},
			{
				Header: "Customer",
				id: "customer",
				accessor: obj => JSON.parse(obj.customer).first_name + ' ' + JSON.parse(obj.customer).last_name
			},
			{
				Header: "Customer Address",
				id: "customer_address",
				accessor: obj => JSON.parse(obj.customer).addresses[0].address_one + ', ' + JSON.parse(obj.customer).addresses[0].city + ', ' + JSON.parse(obj.customer).addresses[0].state + ' ' + JSON.parse(obj.customer).addresses[0].zip
			},
			{
				Header: "Products",
				id: "products",
				// width: ,
				accessor: obj => obj.order_items
			},
			{
				Header: "Order Date",
				id: "order_date",
				accessor: obj => moment(obj.order_date)
					.local()
					.format("MM/DD/YYYY hh:mm A")
			},
			{
				Header: "AmmoReady Status",
				id: "status",
				accessor: obj => obj.status
			},
			{
				Header: "FFLBoss Status",
				id: 'fflboss_status',
				width: 250,
				accessor: obj => obj.ffl_status
					? obj.ffl_status === 'Acquired'
						? obj.ffl_status + ' - ' + moment(obj.acquire_date).local().format("MM/DD/YYYY hh:mm A")
						: obj.ffl_status === 'Transferred' ? obj.ffl_status + ' - ' + moment(obj.transfer_date).local().format("MM/DD/YYYY hh:mm A")
							: obj.ffl_status + ' - ' + moment(obj.disposed_date).local().format("MM/DD/YYYY hh:mm A")
					: "Never Acquired"
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				Cell: props => {
					return (
						props.original.order_items ? <Button
							id={props.original.order_id}
							// binary_id={props.original.binary_id}
							color="danger"
							size={"sm"}
							block={true}
							onClick={this.toggleModalOpen}>
							Review
						</Button> : null
					);
				}
			},


		];
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;

		return (
			<Card>
				<CardContent>
					{this.state.not_acquired_error && <Alert color="danger">
						Error: These products have not been acquired yet. Please acquire the products first, then add them to a transfer.
					</Alert>}
					{this.state.already_acquired_error && <Alert color="danger">
						Error: These products have already been acquired.
					</Alert>}
					{this.state.transfer_error && <Alert color="danger">
						Error: These products have already been transferred.
					</Alert>}
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{<Button color="warning" onClick={this.getAmmoreadyOrders} style={{marginLeft: '25px'}}>Refresh Orders From AmmoReady</Button> }
								{this.renderHeaderRight("Products", columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose,
								)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
							renderPageSizeOptions={this.renderPageSizes}
							pageSize={limit}
							className="-striped -highlight"
							getTrProps={(state, rowInfo) => {
								if (rowInfo && rowInfo.row) {
									return {
										style: {
											background: rowInfo.original.highlightRow ? 'yellow' : 'inherit',
										},
									};
								} else {
									return {};
								}
							}}
						/>


						<UniversalModalOverride
							showModal={this.state.modalImporter}
							locations={this.props.locations}
							states={this.props.states}
							name={"Acquisition"}
							object={Objects.Acquisition}
							history={this.props.history}
							reportClose={() => this.handleReportClose('acquisitionModal')}
							afterSave={() => this.props.history.push('/acquisitions')}
							toggle={this.state.acquisitionModal}
							size={'xl'}
							objectProps={{
								transaction_entries: this.state.ammoready_products,
								order_id: this.state.orderID
								// setBackdrop: (backdrop) => this.setState({backdrop}),
								// setBypass: (bypass) => this.setState({bypass})
							}}
						/>


						<UniversalModalOverride
							locations={rootState.locations}
							states={rootState.states}
							history={this.props.history}
							name={"Transfer"}
							object={Objects.Transfer}
							toggle={this.state.transferModal}
							reportClose={() => this.handleReportClose('transferModal')}
							afterSave={() => this.props.history.push('/transfers')}
							objectProps={{
								transaction_entries: this.state.ammoready_products,
								order_id: this.state.orderID,
							}}
							size={'xl'}

						/>

						<UniversalModalOverride
							locations={rootState.locations}
							states={rootState.states}
							history={this.props.history}
							name={"Disposition"}
							object={Objects.DispositionAdd}
							toggle={this.state.dispositionModal}
							reportClose={() => this.handleReportClose('dispositionModal')}
							afterSave={() => this.props.history.push('/dispositions')}
							objectProps={{
								transaction_entries: this.state.ammoready_products,
								order_id: this.state.orderID
							}}
							size={'xl'}
						/>
					</div>


					<Button color="primary" style={{marginTop: '20px'}} onClick={this.toggleModal}>
						Review
					</Button>
					<Modal
						isOpen={this.state.isModalOpen}
						toggle={this.toggleModal}
						centered
						style={{
							maxWidth: '500px',
							margin: '1.75rem auto'
						}}
					>
						<ModalHeader
							toggle={this.toggleModal}
							style={{
								borderBottom: '1px solid #dee2e6',
								padding: '1rem',
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center'
							}}
						>
							<span style={{ fontSize: '1.25rem', fontWeight: '500', margin: 0 }}>
								Select Transaction Type
							</span>
						</ModalHeader>
						<ModalBody style={{ padding: '1rem' }}>
							<div style={{
								display: 'grid',
								gap: '0.5rem',
								width: '100%'
							}}>
								<Button
									color="outline-primary"
									size="lg"
									style={{
										display: 'block',
										width: '100%',
										padding: '0.75rem 1rem',
										fontSize: '1.1rem',
										fontWeight: '400',
										border: '1px solid #0d6efd',
										borderRadius: '0.25rem',
										marginBottom: '0.5rem',
										background: 'white',
										color: '#0d6efd',
										cursor: 'pointer'
									}}
									onClick={() => this.handleTransactionSelect('acquisition')}
								>
									Acquisition
								</Button>
								<Button
									color="outline-primary"
									size="lg"
									style={{
										display: 'block',
										width: '100%',
										padding: '0.75rem 1rem',
										fontSize: '1.1rem',
										fontWeight: '400',
										border: '1px solid #0d6efd',
										borderRadius: '0.25rem',
										marginBottom: '0.5rem',
										background: 'white',
										color: '#0d6efd',
										cursor: 'pointer'
									}}
									onClick={() => this.handleTransactionSelect('transfer')}
								>
									Transfer
								</Button>
								<Button
									color="outline-primary"
									size="lg"
									style={{
										display: 'block',
										width: '100%',
										padding: '0.75rem 1rem',
										fontSize: '1.1rem',
										fontWeight: '400',
										border: '1px solid #0d6efd',
										borderRadius: '0.25rem',
										background: 'white',
										color: '#0d6efd',
										cursor: 'pointer'
									}}
									onClick={() => this.handleTransactionSelect('disposition')}
								>
									Disposition
								</Button>
							</div>
						</ModalBody>
					</Modal>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
